/**
 * Переключатель светлой и тёмной темы в шапке.
 */
class ThemeColorTurn {

    /**
     * Находит чекбокс темы и применяет сохранённую или системную тему.
     */
    constructor() {
        this.storageKey = 'nft-theme';
        this.lightClass = 'light-mode';
        this.input = document.querySelector('.theme-color-turn__input');
        this.darkMedia = window.matchMedia('(prefers-color-scheme: dark)');
        this.lightMedia = window.matchMedia('(prefers-color-scheme: light)');
        this.init();
    }

    /**
     * Подписывается на смену чекбокса и системной темы.
     */
    init() {
        if (!this.input) {
            return;
        }

        this.applyTheme(this.resolveIsDark(), false);

        this.input.addEventListener('change', () => {
            this.applyTheme(this.input.checked, true);
        });

        this.bindSystemTheme();
    }

    /**
     * Следит за сменой темы ОС, пока пользователь сам ничего не выбрал.
     */
    bindSystemTheme() {
        const onSystemChange = () => {
            if (this.getSavedTheme()) {
                return;
            }

            this.applyTheme(this.getSystemIsDark(), false);
        };

        this.darkMedia.addEventListener('change', onSystemChange);
        this.lightMedia.addEventListener('change', onSystemChange);
    }

    /**
     * Возвращает тему: сохранённый выбор или системная настройка.
     */
    resolveIsDark() {
        const savedTheme = this.getSavedTheme();

        if (savedTheme === 'dark' || savedTheme === 'light') {
            return savedTheme === 'dark';
        }

        return this.getSystemIsDark();
    }

    /**
     * Возвращает true, если в ОС тёмная тема или предпочтение не задано.
     */
    getSystemIsDark() {
        return this.darkMedia.matches || !this.lightMedia.matches;
    }

    /**
     * Возвращает сохранённый ключ темы из localStorage.
     */
    getSavedTheme() {
        try {
            return localStorage.getItem(this.storageKey);
        } catch (error) {
            return null;
        }
    }

    /**
     * Применяет тему и при явном выборе пользователя запоминает её.
     */
    applyTheme(isDark, persist) {
        this.input.checked = isDark;
        document.documentElement.classList.toggle(this.lightClass, !isDark);

        if (!persist) {
            return;
        }

        try {
            localStorage.setItem(this.storageKey, isDark ? 'dark' : 'light');
        } catch (error) {
            return;
        }
    }
}

export default ThemeColorTurn;
